import { useRef, useState, useLayoutEffect } from "react";
import { Box } from "@mui/material";
import Header from "../components/common/Header";
import Sidebar from "../components/sidebar/Sidebar";

function PageLayout({ children, sx }) {
  const headerRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(0);
  const [mobileOpen, setMobileOpen] = useState(false);

  useLayoutEffect(() => {
    const node = headerRef.current;
    if (!node) return;
    const update = () => setHeaderHeight(node.offsetHeight);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "linear-gradient(135deg, #F8FFFE 0%, #E8F5F3 100%)",
      }}
    >
      <Box
        ref={headerRef}
        sx={{
          position: "sticky",
          top: 0,
          zIndex: (theme) => theme.zIndex.appBar,
        }}
      >
        <Header onMenuClick={() => setMobileOpen(true)} />
      </Box>

      <Box sx={{ display: "flex", flex: 1, minHeight: 0 }}>
        {/* Docked rail only exists on desktop - the Sidebar's own temporary
            Drawer handles mobile as a full overlay, so it never reserves
            horizontal space and can't squeeze the page content. */}
        <Box
          sx={{
            display: { xs: "none", md: "block" },
            flexShrink: 0,
            position: "sticky",
            top: headerHeight,
            height: `calc(100vh - ${headerHeight}px)`,
            alignSelf: "flex-start",
          }}
        >
          <Sidebar hasAccess={() => true} /* userRole={currentUser.role} */ />
        </Box>

        {/* Mobile-only overlay drawer (rendered by Sidebar itself) */}
        <Box sx={{ display: { xs: "block", md: "none" } }}>
          <Sidebar
            hasAccess={() => true}
            mobileOpen={mobileOpen}
            onMobileClose={() => setMobileOpen(false)}
          />
        </Box>

        <Box component="main" sx={{ flex: 1, minWidth: 0, overflowY: "auto" }}>
          <Box sx={{ py: "30px" }}>
            <Box
              sx={{
                width: { xs: "92%", sm: "90%", md: "75%", lg: "70%" },
                height: "100%",
                margin: "auto",
                borderRadius: 2,
                ...sx,
              }}
            >
              {children}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default PageLayout;
